<div [id]="backgroundImageId" class="bg-image shadow" color="primary">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-5 col-xl-4 col-xxl-4">
          <form class="bg-white rounded shadow-5-strong p-3" [formGroup]="signUpVerifyForm">
            <div class="d-flex justify-content-center" >
              <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                <img [src]="logoUrl" alt="IEA logo" class="logo" />
              </div>
            </div>
            <div class="col-12 text-center">
              <p class="fw-bold mt-3 lh-2 px-3">
                Please enter the verification code to finish setting up your account.
              </p>
            </div>
            <hr>
            <div class="example-container mt-4">
              <div class="row">
                <div class="col-12">
                  <eq-textInput
                    [label]="'Verification Code'"
                    [icon]="'shield_person'"
                    [form]="signUpVerifyForm"
                    [name]="'otp'"
                    [validators]="otpValidators"
                    class=""
                  ></eq-textInput>
                </div>
                <label class="text-center form-check-label ps-2" for="form1Example3">
                  I didn't receive a code!
                  <a [class.disabled]="resendDisabled" class="text-primary" color="primary"
                    (click)="resend()">Resend</a>
                </label>
              </div>
            </div>


            <button type="button" (click)="verify()" class="mt-2 btn btn-primary btn-block w-100 py-2">
              Verify &amp; Sign In
            </button>
            <div class="col-12 text-center mt-3">
              <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png" alt="IEA logo" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
